import React, { Fragment } from 'react';

import { Button, Switch } from '@mui/material';
import {
  GridAddIcon,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';

import styles from '../PortfoliosPage.module.scss';

export interface PortfoliosCustomToolbarProps {
  onCreateClick: () => void;
  switches: {
    adminPortfolios: {
      isChecked: boolean;
      onToggle: () => void;
    },
    personalPortfolios: {
      isChecked: boolean;
      onToggle: () => void;
    },
  },
}

export const PortfoliosCustomToolbar = (props: PortfoliosCustomToolbarProps) => {
  return (
    <Fragment>
      <GridToolbarContainer>
        <Button onClick={props.onCreateClick}>
          <GridAddIcon />
          Create Portfolio
        </Button>
        <GridToolbarQuickFilter />
        <GridToolbarDensitySelector />
        <div className={styles.toolbarSwitches}>
          Show Admin Portfolios
          <Switch
            checked={props.switches.adminPortfolios.isChecked}
            onChange={props.switches.adminPortfolios.onToggle}
          ></Switch>

          Show Personal Portfolios
          <Switch
            checked={props.switches.personalPortfolios.isChecked}
            onChange={props.switches.personalPortfolios.onToggle}
          ></Switch>
        </div>
      </GridToolbarContainer>
    </Fragment>
  );
}
